import Section from './Section';
import SectionHeader from './SectionHeader';
import { Text, Heading, Button } from '@chakra-ui/react';
import { ArrowCircleRight } from './sharedCode/components/UiElements';
import Link from 'next/link';
import { posts } from './articles';

const BlogSection = () => {
    const sortedPosts = [...posts].sort((a, b) => b.date.localeCompare(a.date));
    const [featuredPost, ...regularPosts] = sortedPosts;

    return (
        <Section
            id="pricing"
            color="white"
            size="small"
            backgroundImage=""
            backgroundImageOpacity={1}
        >
            <div className="container">
                <SectionHeader
                    title={'The productivity tab'}
                    subtitle={'Tips on making your browser work better for you'}
                    size={1}
                    spaced={true}
                    className="has-text-centered"
                />
                <Text textAlign="center" color="gray.600" mt={-4} mb={8}>
                    Looking for a tool?{' '}
                    <Link href="/best-tab-manager-extensions">
                        <Text as="span" color="blue.600" textDecoration="underline">
                            See the tab manager guide
                        </Text>
                    </Link>
                </Text>
                {/* Featured Post */}
                <div className="columns is-centered mb-6">
                    <div className="column is-8">
                        <div
                            className="card"
                            style={{ borderRadius: '12px', overflow: 'hidden' }}
                        >
                            <div className="card-image">
                                <figure className="image is-16by9">
                                    <img
                                        src={featuredPost.coverImage}
                                        alt={featuredPost.title}
                                    />
                                </figure>
                            </div>
                            <div className="card-content">
                                <Text fontSize="sm" color="gray.500" mb={1}>
                                    {featuredPost.date}
                                </Text>
                                <Heading as="h2" fontSize="2xl" mb={2}>
                                    {featuredPost.title}
                                </Heading>
                                <Text fontSize="md" color="gray.600">
                                    {featuredPost.description}
                                </Text>
                                <Link
                                    href={`/blog/${featuredPost.slug}`}
                                >
                                    <Button
                                        variant="outline"
                                        colorScheme="gray"
                                        color="gray.800"
                                        size="sm"
                                        mt={5}
                                        border="1px solid var(--chakra-colors-gray-200)"
                                    >
                                        Read on →
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Regular Posts */}
                <div className="columns is-centered is-multiline">
                    {regularPosts.map((post, index) => (
                        <div className="column is-4" key={index}>
                            <div
                                className="card"
                                style={{
                                    borderRadius: '12px',
                                    overflow: 'hidden'
                                }}
                            >
                                <div className="card-image">
                                    <figure className="image is-16by9">
                                        <img
                                            src={post.coverImage}
                                            alt={post.title}
                                        />
                                    </figure>
                                </div>
                                <div className="card-content">
                                    <Text fontSize="sm" color="gray.500" mb={1}>
                                        {post.date}
                                    </Text>
                                    <Heading as="h2" fontSize="xl" mb={2}>
                                        {post.title}
                                    </Heading>
                                    <Text fontSize="sm" color="gray.600">
                                        {post.description}
                                    </Text>
                                    <Link href={`/blog/${post.slug}`}>
                                        <Button
                                            variant="outline"
                                            colorScheme="gray"
                                            size="sm"
                                            mt={5}
                                            color="GrayText"
                                            border="1px solid var(--chakra-colors-gray-200)"
                                        >
                                            Read on →
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
};

export default BlogSection;
